const HOST = process.env.HOST
const ipFile = require('../../build/ip')
const host = process.env.NODE_ENV === 'development' ? '10.1.20.192' :  (HOST || ipFile.getIp() === '127.0.0.1' ? window.location.host : ipFile.getIp())
const proto = window.location.protocol || 'http:'
const httpProto = proto.indexOf('https')>-1?'https':'http'
const wsProto = proto.indexOf('https')>-1?'wss':'ws'
//const host = '192.168.31.112'
//直播流使用的端口，主要用来逃避同源限制，一个端口可以播放6个流
//对应NGINX监听的端口
const cameraPort = [8030,8031,8032,8033,8034]
const cameraPorts = [8035,8036,8037,8038]
export default {
  /**
   * 显示在浏览器标签的title
   */
  title: '',
  sys_version: 'V2.2.0',
  server_ip: host,
  wsPort: '7066',
  wssPort: '7067',
  port: cameraPort,
  httpsPorts: cameraPorts,
  wsProto: wsProto,
  httpProto:httpProto,
  ws: wsProto + '://'+host+'/DisWebSocket/websocket',
  sysUrl: httpProto + '://'+host+'/YunEasy/upload/',
  bmapUrl: httpProto + '://' + host + '/YunEasy/system/',
  cookieExpires: 30,//token 存储 cookie 时间 单位：天
  useI18n: true,
  baseUrl: {
    dev:httpProto+'://'+host+'/',
    pro:httpProto + '://'+host+'/'
  },
  whiteLogo:{
    zh: '/broad/static/images/logo/white/logo_cn.png',
    en: '/broad/static/images/logo/white/logo_en.png',
    tw: '/broad/static/images/logo/white/logo_tw.png'
  },
  blackLogo:{
    zh: '/broad/static/images/logo/black/logo_cn.png',
    en: '/broad/static/images/logo/black/logo_en.png',
    tw: '/broad/static/images/logo/black/logo_tw.png'
  },
  blueLogo:{
    zh: '/broad/static/images/logo/blue/logo_cn.png',
    en: '/broad/static/images/logo/blue/logo_en.png',
    tw: '/broad/static/images/logo/blue/logo_tw.png'
  },
  index_title:{
    zh:'IP广播对讲融合调度软件',
    en:'IP Intercom Server',
    tw:'IP廣播對講融合調度軟件'
  },
  homeName:'control',
  plugin: {
    /*'error-store': {
      showInHeader: false,
      developmentOff: true
    }*/
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/config/index.js
// module id = FwDG
// module chunks = 24